import { render } from "./Logo.vue?vue&type=template&id=635d8a13"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=635d8a13&lang=scss"

import exportComponent from "/builds/mindthegapstudio/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__